import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PurchaseManagerModalService {

  private selectedPurchaseManagerSubject = new BehaviorSubject<any>(null);
  public selectedPurchaseManager$ = this.selectedPurchaseManagerSubject.asObservable();

  private preSelectedVehicleSubject = new BehaviorSubject<any>(null);
  public preSelectedVehicle$ = this.preSelectedVehicleSubject.asObservable();

  constructor() { }

  setSelectedPurchaseManager(purchaseManager: any): void {
    this.selectedPurchaseManagerSubject.next(purchaseManager);
  }

  getSelectedPurchaseManager(): any | null {
    return this.selectedPurchaseManagerSubject.value;
  }

  clearSelectedPurchaseManager(): void {
    this.selectedPurchaseManagerSubject.next(null);
  }

  setPreSelectedVehicle(vehicle: any): void {
    this.preSelectedVehicleSubject.next(vehicle);
  }

  getPreSelectedVehicle(): any | null {
    return this.preSelectedVehicleSubject.value;
  }

  clearPreSelectedVehicle(): void {
    this.preSelectedVehicleSubject.next(null);
  }
}
